import { useQuery } from "@tanstack/react-query";
import * as AgenticV2API from "@/services/api/agentic-v2";
import type { ArtifactKind } from "@/services/api/agentic-v2";
import { useCompanyId } from "@/context/CompanyContext";
import { useWindowLive } from "@/components/ui/os-layout/WindowActiveContext";
import { clientsKeys } from "./keys";

export interface UseClientArtifactsOptions {
  faClientId: string;
  limit?: number;
  kind?: ArtifactKind;
  includeArchived?: boolean;
  enabled?: boolean;
}

/** Artefacts attached to an fa_client (shared by Plans and Artefacts tabs). */
export function useClientArtifacts({
  faClientId,
  limit = 500,
  kind,
  includeArchived = false,
  enabled: enabledOption = true,
}: UseClientArtifactsOptions) {
  const isWindowLive = useWindowLive();
  const companyId = useCompanyId();
  const queryEnabled = Boolean(faClientId) && enabledOption && isWindowLive;

  const query = useQuery({
    queryKey: [
      ...clientsKeys.artifacts(faClientId, companyId ?? undefined),
      { limit, kind, includeArchived },
    ],
    enabled: queryEnabled,
    refetchOnWindowFocus: queryEnabled,
    queryFn: () =>
      AgenticV2API.listFaClientArtifacts(faClientId, {
        limit,
        kind,
        include_archived: includeArchived,
      }),
  });

  return {
    artifacts: query.data ?? [],
    loading: query.isLoading,
    error: query.error,
    refresh: () => void query.refetch(),
  };
}
